import { useSelector } from "react-redux"


const useTableCount = () => {
    let count = useSelector(config=>config.config.tableCount)
    return count;
}

export {useTableCount}